import React from "react";
import { motion } from "framer-motion";
import HomeHakkimdaj from "../component/HomeHakkimdaj";
import HomeContact from "../component/HomeContact";
import HomeBranslar from "../component/HomeBranslar";

const list = {
	hidden: {
		opacity: 0,
	},
	visible: {
		opacity: 1,
		transition: {
			duration: 1,
			when: "beforeChildren",
			staggerChildren: 1,
		},
	},
};

const item = {
	visible: {
		opacity: 1,
		y: 0,
	},
	hidden: {
		opacity: 0,
		y: 100,
	},
};

export default function HomePage() {
	return (
		<div>
			<div className="home-hero">
				<motion.div initial="hidden" animate="visible" variants={list}>
					<div className="pb-5">
						<div className="row">
							<motion.div variants={item}>
								<h1 className="text-white text-center mb-3">
									EĞİTİM BİLİMLERİ
								</h1>
							</motion.div>

							<motion.div variants={item}>
								<h2 className="text-white text-center my-3">
									SPOR KULÜBÜ
								</h2>
							</motion.div>

							<motion.div variants={item}>
								<h5 className="text-center fs-5 text-white mt-3">
									Ankara'da profesyonel spor hizmeti vermektedir.
								</h5>
							</motion.div>
						</div>
					</div>
				</motion.div>
			</div>
			<div className="home-hakkimda">
				<HomeHakkimdaj />
			</div>
			<div className="hukuk-bolumler">
				<HomeBranslar />
			</div>
			<div className="home-contact">
				<HomeContact />
			</div>
		</div>
	);
}
